//CSS
import "../../Components/Page/Page.css";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
import { Link } from "react-router-dom";

//Data
import VideoComp from "../../Components/VideoComp/VideoComp2";
// import VdoCipherComp from "../../Components/VdoCipher/VdoCipher";
import YouTubeVideo from "../../Components/VideoComp/YouTubeVideo";

const Validations: React.FC = () => {
    return (
        <div id="Goals" className="sectionContainer">
            <SecHeader title="Validations" />

            <SubSection isSplit={false}>
                <div className="inv-items">
                    <div className="inv-item">
                        <p className="inv-item-body">
                            Review and validation of ELF-Tech™ designs by Knobbe Martens LLP and their IP
                            lawyers and engineers since 2022. Continuous growing IP portfolio with over
                            390 patent claims filed in U.S. and World patent offices. Of the claims that
                            completed determination all have been granted.<br /><br />

                            E-SPEC™ design and modeling software integrates AI use to add data faster and
                            helps with design, comparing, and modeling.
                        </p>
                    </div>
                </div>
            </SubSection>
            <SubSection>

                {/* <VdoCipherComp filename="eta4k" title="ETA 4K" /> */}
                <YouTubeVideo videoId="https://youtu.be/bC3BZhcImXA" title="ETA 4K" />
                {/* <VideoComp width={"60vw"} source="https://www.youtube.com/embed/bC3BZhcImXA?si=6fI9zpMUvZZnR9R5&autoplay=1&controls=1&loop=1&mute=1&playlist=bC3BZhcImXA" /> */}
            </SubSection>
            <SubSection isSplit={false}>
                <div className="inv-items">
                    <div className="inv-item">
                        <p className="inv-item-body">
                            <b>March 2025:</b> first public display of ELF-Tech designs at American Trucking
                            Association (ATA)'s Technology & Maintenance Council (TMC) Annual Meeting &
                            Transportation Technology Exhibition in Nashville, TN.
                        </p>{" "}
                    </div>
                    <div className="inv-item">
                        <p className="inv-item-body">
                            <b>April 2025:</b> new national and international collaborators to license ELF engines.
                        </p>{" "}
                    </div>
                    <div className="inv-item">
                        <p className="inv-item-body">
                            <b>August 2025:</b> first proof of concept assembly V001 {" "}
                            <Link to="../news-protected">(POC1)</Link> engine was completed.
                        </p>{" "}
                    </div>
                    <div className="inv-item">
                        <p className="inv-item-body">
                            <b>September 2025:</b> second proof of concept assembly V002 {" "}
                            <Link to="../news-protected">(POC2)</Link> engine was completed.
                        </p>{" "}
                    </div>
                    <div className="inv-item">
                        <p className="inv-item-body">
                            <b>April 2026:</b> first Badger Test Engine V001 Full Assembly was displayed at Truck World Trade Show in Toronto, Canada.  {" "}
                            <Link to="../news-protected">(BTE1)</Link>
                        </p>{" "}
                    </div>
                    <div className="inv-item">
                        <p className="inv-item-body">
                            <b>August 2026:</b> second test engine will be unveiled in Massachusetts publicly. {" "}
                            <Link to="../news-protected">(BTE2)</Link>
                        </p>{" "}
                    </div>
                </div>
            </SubSection>
        </div>
    );
};

export default Validations;
